import React, {Component} from 'react';
import {Select, Button, Modal, Form, Grid} from 'semantic-ui-react';
import update from 'react-addons-update';

import ProviderData from "../../data/ProviderData";
import resources from "../../data/resources";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {providerDialog} from "../../actions/ProviderDialogAction";
import {selectProvider} from "../../actions/ProviderSelectAction";
import localDB from "../../data/localDB";
import helpers from "../../functions/helpers";
const C = require("../../constants");

class ProviderDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            provider: { id:null, full_name:'', email:'', factory:'', phone:'', phone_prefix: '+57' },
            full_name_error: false,
            email_error: false,
            loading: false,
            countries_phone: helpers.mapPhoneFlagsList(C.CHOICES_COUNTRIES)
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.provider_dialog){
            this.setState({provider:nextProps.provider_dialog.provider});
        }
    }

    handleFullNameChange = (event) => {
        let full_name = update(this.state, {
            provider: {
                full_name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(full_name);
        if (event.target.value.trim() === '') {
            this.setState({full_name_error: true})
        } else {
            this.setState({full_name_error: false});
        }
    };

    handlePhoneChange = (event) => {
        let phone = update(this.state, {
            provider: {
                phone: {
                    $set: event.target.value
                }
            }
        });
        this.setState(phone);
    };

    handleFactoryChange = (event) => {
        let factory = update(this.state, {
            provider: {
                factory: {
                    $set: event.target.value
                }
            }
        });
        this.setState(factory);
    };

    handleEmailChange = (event) => {
        let email = update(this.state, {
            provider: {
                email: {
                    $set: event.target.value.toLowerCase().trim()
                }
            }
        });
        this.setState(email);
        if (event.target.value.trim() !== '') {
            if (resources.validators.isValidEmailAddress(event.target.value)) {
                this.setState({email_error: false})
            } else {
                this.setState({email_error: true})
            }
        } else {
            this.setState({email_error: false})
        }
    };

    async handleSubmit(event) {
        if (this.state.provider.full_name === '') {
            this.setState({full_name_error: true});
        }else if (this.state.email_error) {
            this.setState({email_error: true});
        } else {
            event.preventDefault();
            this.setState({loading: true});
            if (this.state.provider.id) {
                ProviderData.update(this.state.provider, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        res['text'] = res.factory ? `${res.full_name} - ${res.factory}`:res.full_name;
                        localDB.updateDB('providers', res);
                        this.dispatchData(res, 'Proveedor Actualizado!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({loading: false});
                });
            } else {
                ProviderData.add(this.state.provider, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        res['text'] = res.factory ? `${res.full_name} - ${res.factory}`:res.full_name;
                        localDB.addDB('providers', res);
                        this.dispatchData(res, 'Proveedor Agregado!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({loading: false});
                });
            }
        }
    };

    handleClose = () => {
        this.props.providerDialog({open: false, provider:{id:null}});
    };

    handlePhoneCountryChange = (result) => {
        let provider = update(this.state, {
            provider: {
                phone_prefix: {
                    $set: result
                }
            }
        });
        this.setState(provider);
    };

    dispatchData = (provider, message) => {
        this.props.selectProvider(provider);
        this.props.providerDialog({open:false, provider:{id: null, full_name: '', provider:'', factory:'', email:'', phone:'', phone_prefix:'+57'}});
        this.props.showToast({message: message, type: 'success'});
    };

    render() {
        return (
            <div>
                <Modal dimmer='inverted' size='tiny' open={this.props.provider_dialog.open} onClose={this.handleClose}>
                    <Modal.Header>{this.props.provider_dialog.provider.id ? 'Actualizar Proveedor':'Nuevo Proveedor'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Input label='Nombre' placeholder='Nombre' required
                                                        value={this.state.provider.full_name}
                                                        onChange={this.handleFullNameChange}
                                                        error={this.state.full_name_error}/>
                                            <Form.Input label='Empresa' placeholder='Empresa'
                                                        value={this.state.provider.factory}
                                                        onChange={this.handleFactoryChange}/>
                                            <Form.Input type='email' label='Email' placeholder='Email'
                                                        value={this.state.provider.email}
                                                        onChange={this.handleEmailChange}
                                                        error={this.state.email_error}/>
                                            <Form.Input type='text' placeholder='Teléfono' actionPosition='left' label='Teléfono' value={this.state.provider.phone} onChange={this.handlePhoneChange}>
                                                <Select options={this.state.countries_phone} value={this.state.provider.phone_prefix} selection onChange={(e, {value}) => this.handlePhoneCountryChange(value)}/>
                                                <input />
                                            </Form.Input>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' loading={this.state.loading} disabled={this.state.loading} labelPosition='left' onClick={this.handleSubmit}
                                content={this.props.provider_dialog.provider.id ? 'Actualizar':'Guardar'}/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        provider_dialog: state.get('provider_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        providerDialog(data) {
            dispatch(providerDialog(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectProvider(data){
            dispatch(selectProvider(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProviderDialog);


// WEBPACK FOOTER //
// ./src/components/contacts/ProviderDialog.js